import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function FailedMethodsSection() {
  const methods = ['Los manuales oficiales están escritos para abogados y mecánicos, no para conductores que necesitan trabajar ya.', 'Las apps gratuitas te dan preguntas al azar sin explicarte la lógica detrás de la respuesta correcta.', 'Intentar traducir todo al español en tu mente te quita tiempo valioso y te confunde cuando ves la pantalla en inglés.', "Seguir los consejos de 'un primo' que sacó la licencia hace 10 años no funciona porque las leyes del DMV cambian constantemente."];
  return <section className="py-20 bg-slate-900 px-4 sm:px-6 lg:px-8" data-id="element-19">
      <div className="max-w-5xl mx-auto" data-id="element-20">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-21">
          <h2 className="text-3xl md:text-5xl font-oswald font-bold text-white uppercase mb-4" data-id="element-22">
            Por qué lo que intentaste{' '}
            <span className="text-red-500" data-id="element-23">NO funcionó</span>
          </h2>
          <p className="text-xl text-slate-400" data-id="element-24">
            El sistema está diseñado para confundirte, no es tu culpa.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-25">
          {methods.map((method, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-slate-800/50 border border-slate-700 p-6 rounded-xl flex items-start gap-4 hover:border-slate-600 transition-colors" data-id="element-26">
              <XCircle className="w-8 h-8 text-red-500 flex-shrink-0 mt-1" data-id="element-27" />
              <p className="text-slate-300 text-lg leading-relaxed" data-id="element-28">{method}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}